<template>
  <div class="informes">
    <Titulo titulo="Informes" />
    <div class="ml-10por mb-5por mr-5por">
      <div>
        <b-row>
          <b-col cols="12" md="6" align-self="center">
            <h4 class="encuentra-necesitas ml-3">Encuentre rápidamente lo que necesita</h4>
          </b-col>
          <b-col cols="12" md="6">
            <b-row class="filtro">
              <b-col cols="12" lg="3" align-self="center">
                <h4>Filtrado</h4>
              </b-col>
              <b-col cols="12" lg="9" align-self="center">
                <b-row>
                  <b-col cols="12" md="8">
                    <SelectComponet :data="informes" v-model="selectInformes"></SelectComponet>
                  </b-col>
                  <b-col cols="12" md="4">
                    <b-button
                      variant="primary"
                      class="btn-buscar"
                      @click="selectInformes = null"
                    >Limpiar</b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
      <b-row>
        <template v-for="informe in Informes">
          <b-col cols="12" md="3" :key="informe.id" v-if="informe.visible">
            <div class="ficha">
              <div class="mt-5">
                <b-col>
                  <b-row style="height: 180px !important;">
                    <b-col>
                      <br />
                      <h5 class="color-black">{{informe.titulo}}</h5>
                      <p style="font-size: 12px;">{{informe.texto}}</p>
                    </b-col>
                  </b-row>
                  <b-row style="height: 50px !important;">
                    <b-col>
                      <b-button
                        class="button-carga"
                        style="margin:2%"
                        :to="{path:'/informes/'+informe.path}"
                      >Ingresar</b-button>
                    </b-col>
                  </b-row>
                </b-col>
              </div>
            </div>
          </b-col>
        </template>
      </b-row>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

import SelectInformes from "@/data/SelectInformes.json";

export default {
  name: "Informes",
  data() {
    return {
      SelectInformes: SelectInformes,
      selectInformes: null,
      informes: [],
      token: ''
    };
  },
  computed: {
    Informes() {
      let _informes = this.$store.getters["pages/Informes"];

      this.informes = [{ value: null, text: "Seleccionar informe", disabled: true}];
      _informes.forEach(element => {
        if(element.visible){
          this.informes.push(
              { value: element.titulo, text: element.titulo}
          );
        }
      });


      if (this.selectInformes != null) {
        _informes = _informes.filter(
          informe => informe.titulo == this.selectInformes
        );
      }
      return _informes;
    },
    selectFilter() {
      return [...new Set(this.Informes.map(x => x.titulo))];
    }
  },
  methods:{
    irPortalV2(){
      window.open('https://portal.fga.com.co/portal/secciones/informes/informes.php?token='+this.token);
    }
  },
  components: {
    Titulo: () => import("@/containers/layout/Titulo.vue"),
    SelectComponet: () => import("@/components/form/Select.vue")
  },
  created() {
    this.$store.dispatch(
      "pages/setPermisosInforme",
      this.$store.state.user.permisos.find(
        permiso => permiso.descripcion == "informes_portal"
      )
    );
  }
};
</script>
